import maeveGreatEscape from "../../../../src/images/electronics/maeveGreatEscape.mp4";
import earlyLogicProgress from "../../../../src/images/electronics/earlyLogicProgress.mp4";
import React from 'react';
export default {
  maeveGreatEscape,
  earlyLogicProgress,
  React
};